export const DEFAULT_SIMPLE_SCHEMA_TEMPLATE = [
  {
    title: 'Title',
    fieldName: 'title',
    type: 'TEXT',
    uiSections: ['content'],
    hideTitleFromUi: true
  },
  {
    title: 'Subtitle',
    fieldName: 'subTitle',
    type: 'TEXT',
    uiSections: ['content'],
    hideTitleFromUi: true
  },
  {
    title: 'Main image',
    fieldName: 'mainImage',
    type: 'IMAGE',
    uiSections: ['content'],
    hideTitleFromUi: true
  },
  {
    title: 'Content',
    fieldName: 'content',
    type: 'LONGRICHTEXT',
    uiSections: ['content'],
    hideTitleFromUi: true
  },
  { type: 'SEPARATOR' },
  {
    title: 'Sections',
    fieldName: 'sections',
    type: 'LIST',
    fieldOpts: [
      [
        { title: 'type', type: 'TYPE', fieldName: '_listItemType', defaultValue: 'textItems', props: { disabled: true } },
        { type: 'TEXT', title: 'title', fieldName: 'title' },
        { type: 'LONGRICHTEXT', title: 'moreInfo', fieldName: 'moreInfo' },
        { type: 'CHECKBOX', title: 'showInLargeDesign', fieldName: 'largeDesign' },
        {
          title: 'items',
          fieldName: 'textItems',
          type: 'LIST',
          minItems: 1,
          fields: [
            { type: 'TEXT', title: 'title', fieldName: 'title' },
            { type: 'LONGRICHTEXT', title: 'content', fieldName: 'content' },
            { type: 'IMAGE', title: 'image', fieldName: 'image' }
          ]
        }
      ],
      [
        { title: 'type', type: 'TYPE', fieldName: '_listItemType', defaultValue: 'images', props: { disabled: true } },
        { type: 'TEXT', title: 'title', fieldName: 'title' },
        { type: 'LONGRICHTEXT', title: 'moreInfo', fieldName: 'moreInfo' },
        {
          title: 'images',
          fieldName: 'images',
          type: 'TABLE',
          minItems: 1,
          uiType: 'FilesSection',
          hideTitleFromUi: true,
          uiSections: ['images'],
          fields: [
            { title: 'image', type: 'IMAGE', fieldName: '' },
            { title: 'title', type: 'TEXT', fieldName: 'title' },
            { title: 'credit', type: 'TEXT', fieldName: 'credit' }
          ]
        }
      ],
      [
        { title: 'type', type: 'TYPE', fieldName: '_listItemType', defaultValue: 'videos', props: { disabled: true } },
        { type: 'TEXT', title: 'title', fieldName: 'title' },
        { type: 'LONGRICHTEXT', title: 'moreInfo', fieldName: 'moreInfo' },
        {
          title: 'videoFiles',
          fieldName: 'videos',
          type: 'TABLE',
          minItems: 1,
          uiType: 'FilesSection',
          hideTitleFromUi: true,
          uiSections: ['watch'],
          fields: [
            { type: 'FILE', title: 'video', fieldName: '', props: { accept: 'video/*' } },
            { type: 'TEXT', title: 'title', fieldName: 'title' },
            { type: 'TEXT', title: 'moreInfo', fieldName: 'txt' }
          ]
        }
      ],
      [
        { title: 'type', type: 'TYPE', fieldName: '_listItemType', defaultValue: 'links' },
        { type: 'TEXT', title: 'title', fieldName: 'title' },
        { type: 'LONGRICHTEXT', title: 'moreInfo', fieldName: 'moreInfo' },
        {
          title: 'links',
          fieldName: 'links',
          type: 'TABLE',
          minItems: 1,
          uiType: 'FilesSection',
          hideTitleFromUi: true,
          uiSections: ['links'],
          fields: [
            { type: 'TEXT', title: 'link', fieldName: 'src' },
            { type: 'TEXT', title: 'title', fieldName: 'title' },
            { type: 'TEXT', title: 'moreInfo', fieldName: 'txt' }
          ]
        }
      ]
    ]
  }
]

